import { GraphQLProofOfConclusionRequester, type ProofOfConclusion } from '@cobliteam/api-lib';

import type { DateRange, UUID } from '@cobliteam/common-types';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

// Lazy instantiation to avoid circular dependency issues
const getGraphQLProofOfConclusionRequester = () => new GraphQLProofOfConclusionRequester();

export const QUERY_KEY = 'proof-of-conclusion';

const useGetProofsOfConclusion = (
  params?: {
    dateRange?: DateRange;
    activityId?: UUID;
    groupIds?: string[];
  },
  options?: Partial<UseQueryOptions<ProofOfConclusion[]>>
) => {
  const { dateRange, activityId, groupIds } = params || {};
  const limit = 1000;
  const offset = 0;

  return useQuery<ProofOfConclusion[]>({
    queryKey: [QUERY_KEY, offset, limit, dateRange, activityId, groupIds],
    queryFn: () => getGraphQLProofOfConclusionRequester().listProofsOfConclusion(limit, offset, dateRange, activityId, groupIds),
    meta: {
      errorMessage: 'Falha ao carregar provas de conclusão. Tente novamente mais tarde.',
    },
    ...options,
  });
};

export default useGetProofsOfConclusion;
